import type {SwitchProps as ChakraSwitchProps} from '@chakra-ui/react';
import {forwardRef, Switch as ChakraSwitch} from '@chakra-ui/react';

export type SwitchProps = ChakraSwitchProps;

export const Switch = forwardRef<SwitchProps, 'input'>((props, ref) => {
  return <ChakraSwitch {...props} ref={ref} />;
});
